import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { assignManyConsistencyCheckRanTemplate } from '@api/consistencyCheck';

import { IConsistencyCheckBatchDTO } from '@interfaces/cmModule/dto/consistencyCheckDTO';
import { IOnSuccess } from '@interfaces/common/handlers';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { CONSISTENCY_RAN_ASSIGN_MANY_TEMPLATE, CONSISTENCY_RAN_TABLE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateConsistencyCheckRanAssignManyTemplate {
	assignManyTemplate: UseMutateFunction<any, any, IConsistencyCheckBatchDTO, any>;
	isLoadingAssignManyTemplate: boolean;
}

export const useMutateConsistencyCheckRanAssignManyTemplate = ({
	onSuccess,
}: IOnSuccess): IUseMutateConsistencyCheckRanAssignManyTemplate => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate,
		isLoading,
	} = useMutation<IConsistencyCheckBatchDTO>({
		mutationKey: [CONSISTENCY_RAN_ASSIGN_MANY_TEMPLATE],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		mutationFn: assignManyConsistencyCheckRanTemplate,
		onSuccess: () => {
			onSuccess?.();

			dispatch(setSnackbar({
				message: responseMessages.assignManyConsistencyCheckRanTemplate,
				type: ESnackbarTypes.success,
			}));

			return [queryClient.invalidateQueries([CONSISTENCY_RAN_TABLE])];
		},
	});

	return {
		assignManyTemplate: mutate,
		isLoadingAssignManyTemplate: isLoading,
	};
};
